<template>
  <sweet-modal ref="preview_modal" blocking="blocking" width="80%">
    <div>
      <div class="embed-responsive embed-responsive-1by1">
        <iframe class="embed-responsive-item" :srcdoc="html"></iframe>
      </div>
    </div>
  </sweet-modal>
</template>
<script>
import _ from 'lodash';
import Alerts from '@/utils/alerts';

export default {
  //    props: ['columns'],
  data: function () {
    return {
      html: null
    };
  },
  methods: {
    open: function (html) {
      this.html = html;
      this.$refs.preview_modal.open();
    },
    close: function () {
      this.$refs.preview_modal.close();
    }
  }
};
</script>

<style scoped></style>
